<template>
  <div class="select" :class="{'select--pushed-label': labelPushed}">
    <div class="select__wrapper">
      <label class="select__label" :class="{'has-text-danger': error}" :for="identifier">
        {{label}}
      </label>
      <select
        @blur="$emit('blur', $event)"
        :id="identifier"
        :value="value"
        @input="$emit('input', $event.target.value)"
        v-bind="$attrs">
        <slot/>
      </select>
    </div>
    <span
      class="select__error has-text-danger"
      v-if="error">
      {{error}}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'WSelect',
    props: {
      label: String,
      name: String,
      value: String,
      error: String,
    },
    computed: {
      identifier() {
        return this.name
          || this.label.replace(/\s/g, '-')
            .toLowerCase();
      },
      labelPushed() {
        return !!this.value;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../assets/styles/variables";

  .select {
    width: 100%;
    height: auto;
    padding: 12px 0;

    &::after, &:hover::after {
      // remove the caret that bulma adds
      border: none !important;
    }

    &.select--pushed-label {
      .select__label {
        top: 12px;
        font-size: 12px;
      }

      select {
        padding-top: 16px;
      }
    }

    .select__wrapper {
      position: relative;
    }

    .select__label {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      font-size: 16px;
      padding: 4px 16px;
      color: $text-body;
      transform: translateY(-50%);
      transition: all 0.2s;
      font-weight: 500;
      pointer-events: none;
    }

    .select__error {
      position: absolute;
      font-size: 14px;
      padding-left: 16px;
    }

    select {
      appearance: none;
      background-color: $white;
      color: black;
      width: 100%;
      height: 56px;
      border-radius: 16px;
      box-shadow: none;
      padding: 8px 16px;
      font-size: 14px;
      line-height: 14px;
      border: 1px solid transparent;
      outline: none;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 10L12 15L17 10H7Z' fill='%239B9B9D'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: right 20px center;
      transition: all 0.5s;

      &:focus {
        border-color: $primary-main;

        @include shadow-4;
      }

      &:disabled {
        color: $text-body;
      }
    }
  }
</style>
